import React from 'react';
import Shimmer from './Shimmer';

const ServiceShimmer = () => (
    <div className="container mx-auto p-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3].map((item) => (
                <div key={item} className="p-6 rounded-lg border">
                    <Shimmer className="h-12 w-12 mb-4 rounded"/>
                    <Shimmer className="h-6 w-3/4 mb-3 rounded"/>
                    <Shimmer className="h-4 w-full mb-2 rounded"/>
                    <Shimmer className="h-4 w-2/3 rounded"/>
                </div>
            ))}
        </div>
    </div>
);

export default ServiceShimmer;